import Util from "../libraries/util.js";

export default {
  getUsername: () => {},
  getName: () => {
    if (localStorage.access_token === "undefined" || localStorage.refresh_token === "undefined") {
      return "Unknow";
    }
    const user = Util.decode_jwt(localStorage.access_token);
    return user.user.first_name + " " + user.user.last_name;
  }
}


// WEBPACK FOOTER //
// ./src/libraries/user.js